import { HttpParams } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { UserI } from 'src/app/interfaces/user.interface';
import { AuthLoginService } from 'src/app/pages/login/services/auth-login.service';
import { NavbarService } from '../../navbar.service';

interface Notificaciones {
  id: string;
  id_visible: number;
  abierta: boolean;
  link: string;
  fecha_editado: Date;
  fecha_creado: string;
  titulo: string;
  descripcion: string;
  usuario: Partial<UserI>;
}

@Component({
  selector: 'app-nav-button',
  templateUrl: './nav-button.component.html',
  styleUrls: ['./nav-button.component.css'],
})
export class NavButtonComponent {
  @Input('hasMenu') menu: boolean = false;
  @Input('name') name!: string;
  @Input('icon') icon!: IconProp;
  @Input('mobile') mobile: boolean = false;
  @Input('hideButton') hideButton: boolean = false;
  @Input('mobileOpen') mobileOpen: boolean = false;

  show = false;

  hasNewNotifications = false;

  constructor(
    private readonly service: NavbarService,
    private readonly auth: AuthLoginService,
    private readonly router: Router
  ) { }

  async ngOnInit() {
    const userState = await this.auth.returnUserInfoV2('PARTIAL');
    if (!userState) return;

    let params = new HttpParams();

    params = params.set('usuario', userState.user.id!);
    params = params.set('sortBy', 'DESC');
    params = params.set('page', 1);
    params = params.set('perPage', 5);

    this.service.getNotificaciones(params).subscribe({
      next: (data) => {
        this.noti = data.entities as Notificaciones[];
        this.hasNewNotifications = this.noti.some((v) => !v.abierta);
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  noti: Notificaciones[] = [];

  navegar(link: string, abierta: boolean, id: string) {
    if (!abierta) {
      this.service.updateNotificaciones(id, { abierta: true }).subscribe({
        next: (data) => {
          const noti = this.noti.find((i) => i.id === id);
          if (noti) {
            noti.abierta = true;
            this.hasNewNotifications = this.noti.some((v) => !v.abierta);
          }
        },
        error: (e) => { },
      });
    }
    this.router.navigate([link]);
  }

  visible = true;

  goNotificaciones() {
    this.router.navigate(['home/notificaciones']);
  }
}
